export const MODULE_NAME = 'CITY_MODULE';
